<template>
	<div class="swiper-container">
		<div class="partOne">
			<div class="bb">
				<div class="inner-box">
					<div class="duomicn">
						<h1 class="title">谋生活/61MSH.COM</h1>
						<p>灵活就业及企业用工灵活化服务SaaS服务平台</p>
					</div>
				</div>
			</div>
		</div>
		<div class="partTwo">
			<div class="inner-box">
				<div class="Box">
					<div class="leftBox">
						<div class="one">
							<span class="frozen" data-heading="Frozen">“关于谋生活”</span>
						</div>
						<div class="two"></div>
						<div class="three">
							谋生活61MSH.COM是天谋科技集团旗下专注灵活就业及企业用工灵活化服务SaaS服务平台，主要聚焦于酒店、餐饮、零售、文旅等现代城市服务业。<br><br>
							谋生活61MSH.COM基于互联网、云计算、大数据和人工智能领域的新技术应用，构建线上线下融合的一站式HR SaaS服务平台,
							帮助灵活就业者提升劳动效率、增加就业机会、提高劳动收入，帮助企业降低用工成本、提高用工效率、规避用工风险。
						</div>
					</div>
					<div class="rightBox">
						<img src="../assets/msh.png" height="430" width="380" />
					</div>
				</div>
			</div>
		</div>
		<div class="textcenter">
			<div class="tc-phone">
				<div style="margin: 0 15px;"><i class="fa fa-phone" style="font-size: 25px;font-style: normal;"></i>
				</div>
				<span>400-700-9161</span>
			</div>
			<h3>
				灵活就业及企业用工灵活化服务SaaS服务平台
			</h3>
		</div>
		<div class="partThree">
			<div class="inner-box">
				<div style="width:60%">
				<div class="mshcn">
					<div class="dot"></div>
					<div class="txt">61MSH.COM</div>
				</div>
				<div class="mshcnkj">「谋生活」</div>
				<div class="item"><span>➣</span>通过「谋生活」平台，企业自主发单，个人随时接单，AI人脸智能移动考勤，灵活用工者实现随时找活、随时上岗、随时结算；企业用工者实现招聘获取、管理调度、薪水结算。</div>
				<div class="item"><span>➣</span>「谋生活」通过HR SaaS工具切入企业用户，同时链接劳动力和企业，目的就是要让用工企业真正拥有自给自足的劳动力获取能力，同时又能系统化和精细化的管控起来，最后通过平台合理、合规的结算和支付。最终真正实现灵活劳动力的流量+交付+结算的完整闭环。</div>
				</div>
				<div class="imgBox"> 
				<img  src="../assets/images/img/数据场景.png" width="400" height="300"/>
					<!-- <img alt="" src="../assets/images/img/gymsh.png" width="400" height="300"> -->
				</div>
			</div>
		</div>
		<my-footer></my-footer>
	</div>
</template>

<script>
	export default {
		name: 'Index',
		created() {},
		data() {
			return {

			}
		},
		mounted() {

		},
		methods: {}
	}
</script>

<style scoped>
	@font-face {
		font-family: "frozen";
		src: url("https://s3-us-west-2.amazonaws.com/s.cdpn.io/209981/Ice%20kingdom%20-%20Bold%20-%20Por%20Kustren.woff");
	}
	.partOne {
		margin-bottom: 8%;
	}

	.partOne .bb .duomicn {
		/* width: 100%; */
		text-align: center;
	}

	.partOne .bb .duomicn .title {
		font-size: 48px;
		font-family: "frozen", serif; 
		-webkit-text-stroke: 2px #ff8500;
		-webkit-text-fill-color: white;
		color: white;
		-webkit-animation: colochange 1s infinite;
		-webkit-animation-direction: alternate;
	}

	@-webkit-keyframes colochange {
		0% {
			-webkit-text-stroke: 10px #ff8500;
			letter-spacing: 0;
		}

		100% {
			-webkit-text-stroke: 20px #ffaaff;
			letter-spacing: 10px;
		}
	}

	.partTwo {
		height: 450px;
		/* background-color: #f9fafc; */
		display: flex;
		flex-direction: column;
		position: relative;
		margin-top: 30px;
	}

	.partTwo .inner-box .Box {
		display: flex;
		align-items: center;
		justify-content: space-around;
	}

	.partTwo .inner-box .leftBox {
		width: 70%;
		height: 473px;
		/* text-align: center; */
		z-index: 999;
		animation: contentFromRight2Left .6s ease-out;
	}

	.partTwo .inner-box .rightBox {
		width: 35%;
		height: 360px;
		position:relative;
		bottom:110px;
	}

	.frozen {
		/* 最初字体样式 */
		font-size: 30px;
		font-weight: 400;
		margin-left: 20px;
		/* 使用自定义字体 */
		/* font-family: "frozen", serif; */
		/* 设置背景图片 */
		/* background: url(https://s3-us-west-2.amazonaws.com/s.cdpn.io/209981/6963bbf342d87b3a2150bd8f59682b89.jpg); */
		/* 设置文字透明且背景按文字区域裁剪 */
		/* color: transparent; */
		color: #252627;
		-webkit-background-clip: text;
		/* 为了子元素定位 */
		position: relative;
	}

	.frozen::before {
		/* 获取自定义属性文字 */
		content: attr(data-heading);
		/* 使其和父元素文字重叠 */
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		/* 使用颜色混合模式 */
		mix-blend-mode: screen;
		/* 文字透明 */
		color: transparent;
		/* 设置文字阴影 */
		/* text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2), -2px 2px 10px rgba(0, 0, 0, 0.2), -2px -2px 10px rgba(0, 0, 0, 0.2); */
		/* 设置渐变背景 */
		background: linear-gradient(45deg, rgba(255, 255, 255, 0) 45%, rgba(255, 255, 255, 0.8) 50%, rgba(255, 255, 255, 0) 55%, rgba(255, 255, 255, 0) 100%);
		background-size: 200%;
		/* 使用背景图动画 */
		animation: glare 1s infinite;
	}

	/* 设置背景图动画 */
	@keyframes glare {
		0% {
			background-position: -100%;
		}

		100% {
			background-position: 100%;
		}
	}

	.partTwo .inner-box .leftBox .two {
		top: 10px;
		width: 240px;
		height: 1px;
		background-image: linear-gradient(269deg, #ff8500, rgba(255, 133, 0, 0));
		margin-left: -23px;
		margin-bottom: 20px;
		position: relative;
	}

	.partTwo .inner-box .leftBox .two::before {
		width: 9px;
		height: 9px;
		background: #ff8500;
		content: "";
		position: absolute;
		top: -4px;
		right: 0;
	}

	.partTwo .inner-box .leftBox .three {
		width: 672px;
		height: 120px;
		/* font-family: PingFangSC-Light; */
		font-size: 16px;
		color: #252627;
		line-height: 40px;
		font-weight: 200;
		margin: 30px 25px 10px;
	}
	.textcenter {
		background-color: #ff8400;
		color: #fff;
		text-align: center;
		padding: 20px 0 20px;
		border: 1px solid #eff2f8;
		/* background: url(../views/svg.png) no-repeat center; */
	}
	
	.textcenter .tc-phone {
		margin: 20px 0;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.textcenter .tc-phone span {
		font-size: 28px;
		/* font-family: "frozen", serif; */
		/* font-family: PingFangSC-Medium, PingFang SC; */
		font-weight: 500;
		/* color: #ffffff; */
		line-height: 40px;
	}
	
	.textcenter h3 {
		margin: 20px 0;
		font-size: 28px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		/* color: #ffffff; */
		line-height: 45px;
	}
	.partThree {
		/* height: 100%; */
		height: 480px;
		/* background-color: #f9fafc; */
		position: relative;
		margin: 6% 0 0;
	}
	.partThree .mshcn {
		margin-left: 5%;
		margin-bottom: 15px;
		display: flex;
		align-items: center;
	}
	
	.partThree .mshcn .dot {
		width: 12px;
		height: 12px;
		background-color: #ff8400;
		border-radius: 50%;
		margin-right: 10px;
	}
	
	.partThree .mshcn .txt {
		width: 84px;
		height: 20px;
		font-family: "frozen", serif;
		font-size: 18px;
		color: #ff8400;
		font-weight: 700;
	}
	
	.partThree .mshcnkj {
		margin-left: 3%;
		font-size: 40px;
		color: #0d1d34;
		font-weight: 600;
		position: relative;
		margin-bottom: 50px;
	}
	
	.partThree .mshcnkj::before {
		content: "";
		width: 104px;
		height: 2px;
		background-color: #e6e6e6;
		position: absolute;
		left: 70px;
		bottom: -15px;
	}
	
	.partThree .mshcnkj::after {
		content: "";
		width: 70px;
		height: 4px;
		background: #ff8500;
		border-radius: 2px;
		position: absolute;
		left: 27px;
		bottom: -16px;
	}
	
	.partThree .item {
		margin-left: 5%;
		display: flex;
		/* align-items: center; */
		line-height: 40px;
		font-size: 14px;
		color: #6e748c;
		font-weight: 400;
	}
	
	.partThree .imgBox {
		position: absolute;
		right: 0;
		top: 50%;
		margin-top: -10%;
	}
</style>



// WEBPACK FOOTER //
// src/page/Index.vue